// ==========================================================================
//  M   M  EEEEE  N   N  U   U       M   M   OOO   BBB    III  L      EEEEE
//  MM MM  E      NN  N  U   U       MM MM  O   O  B  B    I   L      E
//  M M M  EEE    N N N  U   U       M M M  O   O  BBBB    I   L      EEE
//  M   M  E      N  NN  U   U       M   M  O   O  B   B   I   L      E
//  M   M  E      N   N  U   U       M   M  O   O  B   B   I   L      E
//  M   M  EEEEE  N   N   UUU        M   M   OOO   BBBB   III  LLLLL  EEEEE
// ==========================================================================
// * * * menu mobile

const btnMob = document.querySelector('.mobile-nav-btn');
const navMobActive = document.querySelector('.nav-mobil-on');

btnMob.addEventListener('click', function () {

  btnMob.classList.toggle('active');
  navMobActive.classList.toggle('active-nav-mob');

})

// ===============================================================================================
//  RRRR   EEEEE    A     SSS    SSS   U   U  RRRR         SSS   W   W  III  PPPP   EEEEE  RRRR
//  R   R  E       A A   S      S      U   U  R   R       S      W   W   I   P   P  E      R   R
//  R   R  EEE    A   A   SSS    SSS   U   U  R   R        SSS   W   W   I   P   P  EEE    R   R
//  RRRR   E      AAAAA      S      S  U   U  RRRR            S  W W W   I   PPPP   E      RRRR
//  R  R   E      A   A      S      S  U   U  R  R            S  W W W   I   P      E      R  R
//  R   R  EEEEE  A   A  SSSS   SSSS    UUU   R   R       SSSS    W W   III  P      EEEEE  R   R
// ===============================================================================================
// * * * reassur swiper

const reassurOk = document.getElementById('hp__reassur');


function hpSwiper() {

  var swiper = new Swiper(".mySwiper", {



    
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 4,
        slidesPerGroup: 2,
      },
      1024: {
        slidesPerView: 5,
        slidesPerGroup: 2,
      },
    }
  });
}

if(reassurOk){
  hpSwiper();
} 



// ===================================================================================================================================================================================================================================================================================================================================================================================================
//   CCC     A    TTTTT  EEEEE   GGG    OOO   RRRR   Y   Y       H   H   OOO   V   V  EEEEE  RRRR
//  C   C   A A     T    E      G   G  O   O  R   R  Y   Y       H   H  O   O  V   V  E      R   R
//  C      A   A    T    EEE    G      O   O  R   R   Y Y        HHHHH  O   O  V   V  EEE    R   R
//  C      AAAAA    T    E      G  GG  O   O  RRRR     Y         H   H  O   O   V V   E      RRRR
//  C   C  A   A    T    E      G   G  O   O  R  R     Y         H   H  O   O   V V   E      R  R
//   CCC   A   A    T    EEEEE   GGGG   OOO   R   R    Y         H   H   OOO     V    EEEEE  R   R
// ===================================================================================================================================================================================================================================================================================================================================================================================================
// * * * category hover

if (window.location.href.indexOf("categories") != -1){

  if (window.location.href.indexOf("marches") != -1){

  document.querySelector('.filterAll').classList.remove('filterSelect');
  document.querySelector('.filterMarch').classList.add('filterSelect');

  }
  if (window.location.href.indexOf("formations") != -1){

  document.querySelector('.filterAll').classList.remove('filterSelect');
  document.querySelector('.filterForm').classList.add('filterSelect');

  }
  if (window.location.href.indexOf("portes") != -1){

  document.querySelector('.filterAll').classList.remove('filterSelect');
  document.querySelector('.filterPortes').classList.add('filterSelect');

  }
  if (window.location.href.indexOf("actions") != -1){

  document.querySelector('.filterAll').classList.remove('filterSelect');
  document.querySelector('.filterAct').classList.add('filterSelect');

  }

}

// ========================================================================================================================================================================================================================================================================================================================================================================================================
//  DDD    RRRR    OOO   PPPP   DDD     OOO   W   W  N   N       FFFFF  III  L      TTTTT  EEEEE  RRRR
//  D  D   R   R  O   O  P   P  D  D   O   O  W   W  NN  N       F       I   L        T    E      R   R
//  D   D  R   R  O   O  P   P  D   D  O   O  W   W  N N N       FFF     I   L        T    EEE    R   R
//  D   D  RRRR   O   O  PPPP   D   D  O   O  W W W  N  NN       F       I   L        T    E      RRRR
//  D  D   R  R   O   O  P      D  D   O   O  W W W  N   N       F       I   L        T    E      R  R
//  DDD    R   R   OOO   P      DDD     OOO    W W   N   N       F      III  LLLLL    T    EEEEE  R   R
// ========================================================================================================================================================================================================================================================================================================================================================================================================
// * * * dropdown filter

const dropBtn = document.querySelector('.pages__topDrop--dropdown');
const dropBtn2 = document.querySelector('.pages__topDrop--dropdown2');
const dropSHow = document.querySelector('.dropdown__modal__container');
const dropSHow2 = document.querySelector('.dropdown__modal__container2');
const arrowDrop = document.querySelector('.drop--js--arrow');
const arrowDrop2 = document.querySelector('.drop--js--arrow2');



if(dropSHow){

    dropBtn.addEventListener('click', function () {
      dropSHow.classList.toggle('displayDrop')
      arrowDrop.classList.toggle('arrowToggle');
      if(dropSHow2){
      dropSHow2.classList.remove('displayDrop')
      }
    });

    dropSHow.addEventListener('mouseleave', function () {

      setTimeout(function() {
        dropSHow.classList.remove('displayDrop')
        arrowDrop.classList.remove('arrowToggle');
      }, 500);

    });

}

if(dropSHow2){

  dropBtn2.addEventListener('click', function () {
    if(dropSHow2 && dropSHow){
      dropSHow.classList.remove('displayDrop')
      }
    dropSHow2.classList.toggle('displayDrop')
    arrowDrop2.classList.toggle('arrowToggle');
  });

  dropSHow2.addEventListener('mouseleave', function () {

    setTimeout(function() {
      dropSHow2.classList.remove('displayDrop')
      arrowDrop2.classList.remove('arrowToggle');
    }, 500);

  });


}


// ====================================================================================================
//  FFFFF  III  L      TTTTT  RRRR   EEEEE       PPPP   RRRR    OOO   DDD    U   U  III  TTTTT   SSS
//  F       I   L        T    R   R  E           P   P  R   R  O   O  D  D   U   U   I     T    S
//  FFF     I   L        T    R   R  EEE         P   P  R   R  O   O  D   D  U   U   I     T     SSS
//  F       I   L        T    RRRR   E           PPPP   RRRR   O   O  D   D  U   U   I     T        S
//  F       I   L        T    R  R   E           P      R  R   O   O  D  D   U   U   I     T        S
//  F      III  LLLLL    T    R   R  EEEEE       P      R   R   OOO   DDD     UUU   III    T    SSSS
// ====================================================================================================
// * * * filtre produits

const btnFilter = document.querySelectorAll('.btn--prod');
const cards = document.querySelectorAll('.card__marches');

if(cards){

  btnFilter.forEach((btn) => {

    btn.addEventListener("click", function () {

      let newFilter = this.dataset.selectProds

      cards.forEach((card) => {

        var propsCard = card.childNodes[3].childNodes[5].childNodes[1].dataset.prods

        if(propsCard.includes(newFilter)){
          card.classList.add('onView');
        } else {
          card.classList.remove('onView');
        }
      
      });

    })
  });

}


// ========================================================================================
//                     FFFFF   OOO    OOO   TTTTT  EEEEE  RRRR        M   M   OOO   BBB
//      /      /       F      O   O  O   O    T    E      R   R       MM MM  O   O  B  B
//     /      /        FFF    O   O  O   O    T    EEE    R   R       M M M  O   O  BBBB
//    /      /         F      O   O  O   O    T    E      RRRR        M   M  O   O  B   B
//   /      /          F      O   O  O   O    T    E      R  R        M   M  O   O  B   B
//  /      /           F       OOO    OOO     T    EEEEE  R   R       M   M   OOO   BBBB
// ========================================================================================
// * * * // footer MOB

const footCols = document.querySelectorAll('.footer__right__col');

footCols.forEach((footCol) => {

  footCol.addEventListener("click", function () {
    footCol.classList.toggle('toggleFoot');

  })
});

// ========================================================================================
//  PPPP     A    N   N  N   N  EEEEE  L           FFFFF  III  L      TTTTT  EEEEE  RRRR
//  P   P   A A   NN  N  NN  N  E      L           F       I   L        T    E      R   R
//  P   P  A   A  N N N  N N N  EEE    L           FFF     I   L        T    EEE    R   R
//  PPPP   AAAAA  N  NN  N  NN  E      L           F       I   L        T    E      RRRR
//  P      A   A  N   N  N   N  E      L           F       I   L        T    E      R  R
//  P      A   A  N   N  N   N  EEEEE  LLLLL       F      III  LLLLL    T    EEEEE  R   R
// ========================================================================================
// * * * Pannel filter

const filterMob = document.querySelector('.mobile--filter__wrapper');
const filterBtn = document.querySelector('.js--filter--btn');
const filterBtnClose = document.querySelector('.js--close--btn');


if(filterMob){

  filterBtn.addEventListener("click", function () {
    filterMob.classList.toggle('mob--filte--on');
  })

  filterBtnClose.addEventListener("click", function () {
    filterMob.classList.remove('mob--filte--on');
  })


}
